<template>
  <GcBaseLayout
    :title="'Scheduler'"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    ref="gc-base-layout"
    class="session-management"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Session Management'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Session Management'"
        :secondaryLabel="undefined"
      />
    </template>

    <div class="session-management-container css-v2" v-if="loaded">
      <div class="main-content" v-if="loaded">
        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
          :rightContainerWidth="250"
        >
          <template #leftContent>
            <div>
              <dx-data-grid
                :dataSource="getLicenseConsumptionSummary"
                :height="height"
                :columnChooser="{
                  enabled: false,
                }"
                :columns="getSummaryColumns"
                @toolbar-preparing="onSummaryToolbarPreparing($event)"
                ref="session-management-list"
                :key="'session-management-list'"
                @rowClick="(e) => e.event.stopPropagation()"
              >
                <DxPaging :page-size="200" :enabled="false" />

                <DxPager :visible="false" />
                <DxScrolling
                  :mode="'virtual'"
                  :row-rendering-mode="'virtual'"
                  :preload-enabled="true"
                />

                <DxMasterDetail
                  :enabled="true"
                  template="masterDetailTemplate"
                />
                <template #masterDetailTemplate="{ data: lineItem }">
                  <dx-data-grid
                    :height="'auto'"
                    :minHeight="300"
                    :columns="getGridColumns"
                    :data-source="getDataSource(lineItem.data)"
                    @toolbar-preparing="onToolbarPreparing($event)"
                    :ref="getLicenseReference(lineItem.data.Code)"
                    :columnChooser="{
                      enabled: false,
                    }"
                    @content-ready="onContentReady"
                    :selection="{
                      mode: 'multiple',
                    }"
                    :elementAttr="{ class: 'session-management-list' }"
                    :key="getLicenseReference(lineItem.data.Code)"
                  >
                    <DxPaging :page-size="200" :enabled="false" />

                    <DxPager :visible="false" />
                    <DxScrolling
                      :mode="'virtual'"
                      :row-rendering-mode="'virtual'"
                      :preload-enabled="true"
                    />
                    <template #status-cell-template="{ data }">
                      <gc-inactive :inactive="!data.data.IsActive" />
                    </template>

                    <template #delete-cell-template="{ data }">
                      <dx-button
                        icon="trash"
                        type="danger"
                        stylingMode="text"
                        @click="
                          (e) => {
                            e.event.stopPropagation();
                            removeSession(data);
                          }
                        "
                      ></dx-button>
                    </template>
                  </dx-data-grid>
                </template>
              </dx-data-grid>
            </div>
          </template>
          <template #rightContent>
            <gc-filter-panel
              :toolbarVisible="true"
              :toolbar="filterToolbar"
              :formItemData="filterFormItems"
              :setGridPanelFilter="setGridPanelFilter"
              :gridFoolter="false"
              :showLoading="showLoading"
              :from="'transaction-screen'"
              :isNormal="false"
              :persistenceKey="undefined"
              :key="'fp-call-schedule'"
              :overWriteClear="true"
            >
            </gc-filter-panel>
          </template>
        </gc-filter-split-view>
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { SessionManagementService } from "../../../_services/api/settings/user/session-management.service";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  data() {
    return {
      loaded: false,
      showLeftContainer: true,
      showRightContainer: true,
      height: "auto",
      backButtonRoute: `/settings/user`,
    };
  },
  mounted() {
    setTimeout(() => {
      var scrollableView = document.getElementsByClassName(
        "layout-body dx-scrollview"
      );

      this.height = scrollableView[0].clientHeight - 30;
    }, 250);
  },
  computed: {
    getLicenseConsumptionSummary() {
      return SessionManagementService.dataSourceConfig(
        "api/LicenseConsumptionSummary",
        {
          sort: [{ selector: "Code", asc: true }],
          expand: "UserSessions",
        }
      );
    },

    getSummaryColumns() {
      return [
        {
          dataField: "Description",
          caption: "License Type",
          minWidth: 200,
        },
        {
          dataField: "ActiveSessionCount",
          caption: "Active Sessions",
          minWidth: 150,
          calculatedCellValue: function (data) {
            return data.UserSessions ? data.UserSessions.length : 0;
          },
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              hint: "Delete",
              icon: "trash",
              onClick: async (e) => {
                this.removeSessions(e);
              },
            },
          ],
          fixed: true,
          fixedPosition: "right",
          width: 50,
        },
      ];
    },

    getGridColumns() {
      return [
        {
          dataField: "Username",
          filterDataField: "Username",
          caption: "Username",
          filterLabel: "Username",
          minWidth: 150,
        },
        {
          screenField: "StartTime",
          type: "DateTime",
          format: "dd MMM yyyy HH:mm:ss",
          dataField: "CreatedAt",
          caption: "Session Created",
          minWidth: 150,
          allowSorting: true,
        },
        {
          screenField: "StartTime",
          type: "DateTime",
          format: "dd MMM yyyy HH:mm:ss",
          dataField: "LastActivityAt",
          filterDataField: "LastActivityAt",
          caption: "Last Activity",
          width: ColumnWidth.Date.width,
          minWidth: 150,
          allowSorting: true,
        },
        {
          screenField: "CreatedBy",
          dataField: "DeviceFingerprint",
          filterDataField: "DeviceFingerprint",
          caption: "Device ID",
          width: 300,
          allowSorting: false,
        },
        // {
        //   screenField: "CreatedBy",
        //   dataField: "LicenseType",
        //   filterDataField: "LicenseType",
        //   minWidth: 150,
        // },
        {
          // screenField: "OrderStatus",
          caption: "",
          dataField: "FriendlyStatus",
          visible: true,
          minWidth: 100,
          cellTemplate: "status-cell-template",
          fixed: true,
          fixedPosition: "right",
          allowSorting: false,
        },

        {
          dataField: "",
          caption: "",
          cellTemplate: "delete-cell-template",
          fixed: true,
          fixedPosition: "right",
          width: 50,
        },
      ];
    },

    filterFormItems() {
      return [
        {
          screenField: "CreatedBy",
          dataField: "Username",
          filterDataField: "Username",
          label: "Username",
          filterLabel: "Username",
          filterIndex: 1,
        },
        {
          screenField: "StartTime",
          type: "Date",
          dataField: "CreatedAt",
          filterDataField: "CreatedAt",
          filterLabel: "Session Created",
          dateVariant: "UTC",
          filterIndex: 3,
          visible: false,
          showInColumnChooser: false,
        },
      ];
    },
    filterToolbar() {
      return {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.onFilterToolbarClose();
          },
        },
      };
    },
  },
  methods: {
    onFilterToolbarClose() {
      this.showRightContainer = !this.showRightContainer;
      this.$nextTick(() => {
        this.reSizeGrid();
      });
    },
    getLicenseReference(code) {
      const setCode = code ? code.replace(/\s/g, "").toLowerCase() : "all";
      return `session-management-list-${setCode}`;
    },
    openFilterPanel() {
      this.showRightContainer = true;
    },

    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },

    onSummaryToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return item.name !== "searchPanel";
      });

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(searchPanel, {
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          validationGroup: "formsData",
          elementAttr: { id: "filter-btn" },
          icon: "filter",
          onClick: () => {
            this.openFilterPanel();
          },
          visible: !this.showRightContainer,
        },
      });
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    getDataSource(data) {
      return SessionManagementService.dataSourceConfig("api/UserSessionList", {
        sort: [{ selector: "Username", asc: true }],
        filter: [[["LicenseType", "=", `${data.Code}`]]],
        postProcess: (data) => {
          data.forEach((element) => {
            if (element.LastActivityAt)
              element.LastActivityAt = element.LastActivityAt.dateWithOffset();

            if (element.CreatedAt)
              element.CreatedAt = element.CreatedAt.dateWithOffset();
          });
          return data;
        },
      });
    },

    /**
     * On Content Ready
     * @param e Event
     */
    onContentReady(e) {
      if (e) {
        this.addGridNoResults(e, {
          addNew: {
            class: "no-data",
            title: "No Active Sessions",
            message:
              "There are no active sessions linked to this license type.",
          },
        });
      }
    },

    async removeSessions(e) {
      if (!e) return;

      const rowData = e.row ? e.row.data : null;
      if (!rowData) return;

      if (rowData.UserSessions.length == 0) {
        this.$alert(
          "There are no active sessions linked to this license type.",
          "Remove Failed"
        );
        return;
      }

      let selectedRows =
        this.$refs[
          this.getLicenseReference(rowData.Code)
        ].instance.getSelectedRowsData();

      if (selectedRows.length > 0) {
        let confirmRemove = await this.$confirm(
          "Are you sure you want to remove the selected sessions?",
          "Remove Sessions"
        );

        if (!confirmRemove) return;

        var selectedSessionIds = selectedRows.map((row) => row.SessionId);
        SessionManagementService.removeSessions(selectedSessionIds)
          .then((res) => {
            this.$notify(
              `The selected session(s) have been removed successfully.`,
              "success"
            );
            if (res) {
              this.reloadDataSource();
            }
          })
          .catch((err) => {
            if (err) this.displayServerError(err, "Remove Failed");
          });
      } else {
        this.$alert(
          "At least one Session line should be selected.",
          "Remove Failed"
        );
      }
    },

    async removeSession(e) {
      const data = e.row.data;
      if (!data) return;

      let confirmRemove = await this.$confirm(
        "Are you sure you want to remove this session?",
        "Remove Session"
      );

      if (confirmRemove) {
        this.showLoading(true);
        await SessionManagementService.removeSession(data.SessionId)
          .then((res) => {
            this.$notify(
              `The selected session(s) have been removed successfully.`,
              "success"
            );
            if (res) {
              this.reloadDataSource();
            }
            this.showLoading(false);
          })
          .catch((err) => {
            if (err) this.displayServerError(err, "Remove Failed");
            this.showLoading(false);
          });
      }
    },

    reloadDataSource() {
      this.$refs["session-management-list"].instance.refresh();
    },

    setGridPanelFilter(filters, valueChanged) {
      if (!this.$refs["session-management-list"]) return;
      let dataGrid = this.$refs["session-management-list"].instance;
      if (valueChanged != undefined || filters.length > 0) {
        if (dataGrid) {
          const getVisibleRows = dataGrid.getVisibleRows();

          if (getVisibleRows.length > 0) {
            getVisibleRows
              .filter((x) => x.rowType === "data")
              .forEach((row) => {
                const rowData = row.data;

                if (this.$refs[this.getLicenseReference(rowData.Code)]) {
                  const detailsGrid =
                    this.$refs[this.getLicenseReference(rowData.Code)].instance;
                  if (detailsGrid) {
                    let newFilter = [];
                    if (filters.length > 0) {
                      newFilter = [...filters];
                      newFilter.push("and");
                      newFilter.push(["LicenseType", "=", `${rowData.Code}`]);
                      detailsGrid.filter(newFilter);
                    } else if (filters.length == 0)
                      detailsGrid.filter([
                        "LicenseType",
                        "=",
                        `${rowData.Code}`,
                      ]);
                    // detailsGrid.refresh(true);
                  }
                }
              });
          }
        }

        dataGrid.refresh(true);
      }
      this.showLoading(false);
    },

    reSizeGrid() {
      let dataGrid = this.$refs["session-management-list"].instance;

      dataGrid.beginUpdate();
      dataGrid.updateDimensions();
      dataGrid.endUpdate();
    },
  },

  async created() {
    this.loaded = true;
  },
};
</script>

<style lang="scss">
.session-management {
  .session-management-container {
    padding: 10px;

    .main-content {
      background: #ffffff;

      .item-title-template {
        padding: unset;
        padding-left: 12px;
        height: 40px !important;

        .item-header {
          font-family: Roboto;
          font-weight: 700;
          font-size: 16px;
          line-height: 38px;
          letter-spacing: 0%;
          color: var(--colors-text-text-tertiary-600, #475467);

          .active-sessions {
            margin-left: 15px;
            background: var(
              --Component-colors-Utility-Success-utility-success-500,
              #17b26a
            );
            padding: 5px 10px;
            border-radius: 12px;
            font-family: Roboto;
            font-weight: 400;
            font-size: 12px;
            leading-trim: NONE;
            line-height: 18px;
            letter-spacing: 0%;
            text-align: center;
            color: var(--Colors-Text-text-primary_on-brand, #ffffff);
          }
        }
      }

      .dx-accordion.dx-widget {
        margin: unset;
      }

      .dx-accordion-item-opened {
        margin: 1px 0 !important;
      }

      .dx-accordion-item-body {
        padding: 0 !important;
      }

      .dx-master-detail-row {
        .dx-datagrid.dx-gridbase-container .dx-datagrid-header-panel {
          display: none !important;
        }
      }
    }
  }
}

/* Enable click events inside master-detail grid */
.session-management .dx-master-detail-row .dx-datagrid-rowsview {
  pointer-events: auto !important;
  z-index: 10;
}

/* Also apply for button columns in child grid */
.session-management .dx-master-detail-row .dx-button,
.session-management .dx-master-detail-row .dx-select-checkbox {
  pointer-events: auto !important;
  cursor: pointer;
}
</style>
